exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5ee454a1] .avatar-uploader .el-upload{width:148px;height:148px;border:1px dashed #dcdfe6;background-color:#fbfdff;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}[data-v-5ee454a1] .avatar-uploader .el-upload:hover{border-color:#20a0ff}[data-v-5ee454a1] .avatar-uploader-icon{font-size:28px;color:#8c939d;width:148px;height:148px;line-height:148px;text-align:center}[data-v-5ee454a1] .avatar{width:148px;height:148px;display:block}\n", ""]);

// exports
